import Card from 'components/Layout/Card';
import { useNavigate } from 'react-router-dom';
import { icons } from 'utils/constants';
import Profile from 'components/Layout/Profile';
import moment from 'moment';
import { useMemo, useState } from 'react';

const UserProfileDetailsCard = ({ user_details, navigation = false, isViewProfile = false ,onClick}) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded((prev) => !prev);
  const researchProfileCount = user_details?.profile_completion || 0;
  const careerObjective = user_details?.career_objective;
  const careerObjectiveText = useMemo(
    () =>
      careerObjective
        ?.replace(/<\/?p>/g, '')
        ?.replace(/<\/?span[^>]*>/g, '')
        ?.trim(),
    [careerObjective]
  );
  const careerObjectiveWords = useMemo(
    () => careerObjectiveText?.split(' ')?.filter(Boolean),
    [careerObjectiveText]
  );
  return (
    <Card>
      {navigation &&
        <div className="d-flex p-2" onClick={() => navigate(-1)}>
          <img src={icons.leftArrow} alt="back" className="h-21 me-3 pointer" />
        </div>}
      <div className="d-flex align-items-center justify-content-center cpt-17">
        <Profile
          isRounded
          isRoundedBorder
          size="s-150"
          isS3UserURL
          url={user_details?.profile_photo_path}
          text={user_details?.user_name}
          displayText={user_details?.user_name}
        />
      </div>
      {user_details?.user_name && (
        <div className="text-20-400-25 text-center cmt-20 ">
          {user_details?.user_name}
        </div>
      )}
      {user_details?.current_plan && (
        <div className="text-16-400-20 text-center cmt-12 color-black-olive">
          {user_details?.current_plan}
        </div>
      )}
      <div className="cmt-30 cps-24 cpb-20 cpe-24">
        <div className="cmb-24 d-flex justify-content-between cmb-16 gap-3">
          <div className="d-flex justify-content-between flex-column flex-grow-1 pt-1">
            <div
              className={`d-flex justify-content-between ${researchProfileCount < 100 ? '' : 'mb-2'
                }`}
            >
              <div className="text-14-400-20 color-title-navy">
                Profile Status
              </div>
              <div className="text-14-400-20 color-title-navy">
                {researchProfileCount >= 100 ? 100 : researchProfileCount}%
              </div>
            </div>
            <div className="progress" style={{ height: '6px' }}>
              <div
                className="progress-bar bg-lime-green"
                role="progressbar"
                style={{ width: `${researchProfileCount}%` }}
                aria-valuenow={researchProfileCount}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
        </div>

        {user_details?.email_id && (
          <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-16 text-break">
            <i className="bi bi-envelope" /> {user_details.email_id}
          </div>
        )}

        {user_details?.phone_number && (
          <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-16">
            <i className="bi bi-telephone" /> {user_details.phone_number}
          </div>
        )}

        {user_details?.country_name && (
          <div className="text-14-300-17 color-black-olive d-flex align-items-center gap-2 cmb-16">
            <i className="bi bi-globe-americas" /> {user_details.country_name}
          </div>
        )}

        {(user_details?.date_of_birth || user_details?.gender) &&
          <div className="row cmb-16 color-black-olive gap-2">
            {user_details?.date_of_birth && (
              <div className="col-md-5 col-12">
                <div className="text-14-400-18 cmb-4">DOB :</div>
                <div className="text-14-300-18">
                  {moment(user_details.date_of_birth).format('DD-MMM-YYYY')}
                </div>
              </div>
            )}

            {user_details?.gender && (
              <div className="col-md-6 col-12">
                <div className="text-14-400-18 cmb-4">Gender :</div>
                <div className="text-14-300-18">{user_details.gender}</div>
              </div>
            )}
          </div>}

        {careerObjective && (
          <div className="text-14-300-17 color-black-olive">
            <div className="cmb-4 text-14-400-18">Career Objective :</div>
            <div className="text-14-300-24 color-black-olive">
              <div>
                {isExpanded ? (
                  <span dangerouslySetInnerHTML={{ __html: careerObjective }} />
                ) : (
                  <>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: careerObjectiveWords.slice(0, 10).join(' '),
                      }}
                    />
                    {careerObjectiveWords.length > 10 && (
                      <>
                        {'... '}
                        <span
                          onClick={toggleReadMore}
                          className="text-12-400-15 color-7cff pointer"
                        >
                          Read More
                        </span>
                      </>
                    )}
                  </>
                )}
              </div>
              {isExpanded && (
                <span
                  onClick={toggleReadMore}
                  className="text-12-400-15 color-7cff pointer"
                >
                  Read Less
                </span>
              )}
            </div>
          </div>
        )}

        {isViewProfile &&
          <div className='d-flex justify-content-center align-items-center color-7cff pointer text-14-500-18' onClick={onClick}>
            View Profile
          </div>}
      </div>
    </Card>
  );
};

export default UserProfileDetailsCard;
